/**
 * Game Timing Constants
 *
 * Centralized timing values for game animations and state transitions.
 * All values in milliseconds.
 */

/**
 * Duration of dice roll animation before showing final value
 */
export const DICE_ANIMATION_DURATION_MS = 1000;

/**
 * Delay before ending turn after dice roll (allows player to see result)
 */
export const TURN_END_DELAY_MS = 1500;

/**
 * Delay before ending turn after pawn release animation
 */
export const PAWN_ANIMATION_DELAY_MS = 800;

/**
 * Delay before automove dice roll animation starts.
 * Gives a visual "breathing room" between turns so automove doesn't feel instant.
 */
export const AUTOMOVE_PRE_ROLL_DELAY_MS = 800;

/**
 * Brief delay before auto-move executes after dice animation completes
 * Allows player to see the dice value before pawn automatically moves
 */
export const AUTO_MOVE_DELAY_MS = 800;

/**
 * Minimum time to let the dice "settle" visually after Ably event arrives.
 * Used when the dice animation has already been running since the user tapped.
 */
export const MIN_DICE_SETTLE_MS = 150;
